import { MOBILE_WIDTH } from "../../config";
import { COLOR_ELEVATION, radius, spacing } from "./../../styleConfig";
import styled from "styled-components";

export const FlexContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: spacing(2);
  border-radius: ${radius(3)};
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.25);
  background-color: ${COLOR_ELEVATION};
  width: 100%;
  padding: ${spacing(3)};
  height: fit-content;
  overflow-x: hidden;
  overflow-y: auto;
  margin: ${spacing(3)};

  @media (max-width: 1000){
    align-items: center;
  }
`;
